export default __webpack_public_path__ + "media/images/front/municipality_collaboration/kochi/ogp-4223cd029872cc4cefff97c0947f6e0b.png";